/**
 * Service worker registration.
 *
 * Production only. A service worker in development caches the very files Vite
 * is trying to hot-reload, which produces the worst debugging experience in
 * front-end work: edits that appear to do nothing.
 */

export function registerServiceWorker(): void {
  if (!import.meta.env.PROD) return;
  if (!('serviceWorker' in navigator)) return;

  // After load, not during: registration competes with the roster fetch and the
  // fonts for the same connection, and none of what it caches is needed on this
  // visit — only the next one.
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      // An unregistrable worker means no offline support, which is a
      // degradation, not a failure. The game works either way.
    });
  });
}
